import defaultTo from "lodash/defaultTo";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { MenuItem } from "../../types/Menu";
import { Flex } from "../Flex";
import { MenuItemLink } from "../MenuItemLink";

export interface MobileMenuItemProps {
  currentPath: string;
  active?: boolean;
  item: MenuItem;
  onItemClick: () => void;
}

export const MobileMenuItem: React.FC<MobileMenuItemProps> = ({ active, item, onItemClick }) => (
  <Flex as="li" alignItems="center" mt={2} mb={3} minHeight={45}>
    <MenuItemLink
      to={item.url}
      onClick={onItemClick}
      fontSize={4}
      color="white"
      borderBottom={active || !isEmpty(item.baseColor) ? "1px solid" : ""}
      borderColor={active ? item.highlightColor : defaultTo(item.baseColor, "")}
      py={2}
    >
      {item.title}
    </MenuItemLink>
  </Flex>
);

MobileMenuItem.defaultProps = {
  active: false,
};
